<template>
    <hb-modal v-model="dialog" size="large" title="Update Task" show-help-link>
        <template v-slot:content>
            <hb-form label="Assign to"
                description="Select one or multiple role(s) AND/OR user(s) to filter from.">
                <hb-combobox 
                    v-model="taskData.assignTo"
                    class="mh-550px" 
                    :search-input.sync="searchAssignees"
                    @change="clearSearchAssignees"
                    @keydown.enter="clearSearchAssignees" 
                    :items="taskAssignees"
                    item-text="name"
                    item-value="id" prepend-inner-icon="mdi-magnify" label="Search roles or users" />
            </hb-form>
        </template>
        <template v-slot:actions>
            <hb-btn color="primary" :disabled="isLoading($options.name)" :loading="isLoading($options.name)"
                @click="updateTaskEvent">Update Task
            </hb-btn>
        </template>
    </hb-modal>
</template>

<script>

import { notificationMixin } from  '../../../mixins/notificationMixin.js';
import api from '../../../assets/api.js'

export default {
    name: 'UpdateSystemTask',
    mixins: [ notificationMixin ],
    props: {
        value: {
            type: Boolean,
            default: false
        },
        taskAssignees: {
            type: Array,
            default: []
        },
        taskDetails: {
            type: Object, 
            default: null
        },
        fetchTasksCount: {
            type: Function,
            default: () => {}
        },
        fetchTasks: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            assignes: [],
            searchAssignees: '',
            taskData: {}
        }
    },
    created() {
        if (this.taskDetails?.id) this.taskData = Object.assign({}, this.taskDetails)
    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
       async updateTaskEvent() {
            
            let payload = {
                task_type_id: this.taskData.task_type_id,
                Assignees: this.taskAssignees.length !== this.taskData.assignTo.length ? this.taskData.assignTo.filter(item => item && item.id).map(item => {
                    return {
                        type: item.is_role ? 'role' : 'user',
                        id: item.id
                    }
                }) : []
            }

            try {
                await api.put(this,  api.TASKS_CENTER +  this.taskData.id, payload);
                this.showMessageNotification({type: 'success', description: "The task has been successfully saved."});
                this.dialog = false;
                this.fetchTasks(true);
            } catch (error) {
                this.showMessageNotification({type: 'error', description: error});
            }
        },
        clearSearchAssignees() {
            if(this.searchAssignees) this.searchAssignees = '';
        },
    }
}
</script>

<style lang="scss" scoped>
.mh-550px {
    min-height: 550px;
}
</style>